/* unplugin-vue-components disabled */import script from "./race-honors.vue?vue&type=script&lang=jsx"
export * from "./race-honors.vue?vue&type=script&lang=jsx"

import "./race-honors.vue?vue&type=style&index=0&id=be80f606&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be80f606"]])

export default __exports__